import { render, staticRenderFns } from "./ReviewPurchase.vue?vue&type=template&id=7bec5ac2&scoped=true&"
import script from "./ReviewPurchase.vue?vue&type=script&lang=js&"
export * from "./ReviewPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPurchase.vue?vue&type=style&index=0&id=7bec5ac2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bec5ac2",
  null
  
)

export default component.exports